import _ from 'lodash';
const PFStore = {
  install(Vue) {
    const root = new Vue({
      // Define the data store for the gnav app
      data: function() {
        return {
          env: `${process.env.NODE_ENV}`,
          servicesb: [
            {
              name: 'Programme &amp; Project Management',
              id: 'programmes_projects',
              children: [
                'Strategic advisory',
                'Transformation roadmaps',
                'Programme Management',
                'Project Management',
                'PPM Health check and remediation',
                'Business analysis',
                'Organisational Change Management'
              ]
            },
            {
              name: 'Enterprise Service Management',
              id: 'enterprise_service_management',
              // summary: 'An Enterprise Service Management implementation isn’t a set and forget process. Like any service, it needs to evolve and adapt as your business changes and grows. We help you ensure your ESM/ITSM implementation stays relevant to your business needs, with the flexibility to adapt to evolving requirements.',
              children: [
                'Implementation roadmaps',
                'Solution architecture',
                'Platform implementation and support',
                'Service Catalogue design and build',
                'CMDB design, implementation, integration and automation',
                'Health check and maturity assessment',
                'ITIL service design and implementation'
              ]
            },
            {
              name: 'Applications development',
              id: 'software_apps',
              children: [
                'System strategy and roadmap',
                'Solution architecture & design',
                'Build, test and deploy',
                'Support and environment management',
                'Health check and maturity assessment',
                'Cloud application configuration and customisation'
              ]
            },
            {
              name: 'System Integrations',
              id: 'systems_integration',
              children: [
                'Integration strategy and roadmap',
                'Integration solution architecture & design',
                'Integration build, test and deploy',
                'Integration support and environment management',
                'Integration health check and maturity assessment',
                '<abbr title="Centre for Enablement">C4E</abbr> design, implementation and support services'
              ]
            },
            {
              name: 'User Experience',
              id: 'experience_design',
              children: [
                'User/Customer experience design',
                'User research',
                'User engagement/testing',
                'UX health check',
                'In-depth UX review & analysis',
                'Prototyping',
                'User Interface design'
              ]
            }
          ],
          services: [
            {
              name: 'IT Strategy and Advisory',
              id: 'it_strategy_advisory',
              children: [
                'Strategy and planning',
                'Sourcing and procurement',
                'Commercial contracts',
                'Operational improvement',
                'Process analysis'
              ]
            },
            {
              name: 'Programmes and Projects',
              id: 'programmes_projects',
              children: [
                'Project and Programme Management',
                'Business analysis',
                'Project rescue',
                'Improvement programmes',
                'Agile methodologies and adoption'
              ]
            },
            {
              name: 'Solution Architecture',
              id: 'solution_architecture',
              children: [
                'Solution roadmp and strategy',
                'Solution design and implementation',
                'Cloud and on-premise',
                'Database architecture'
              ]
            },
            {
              name: 'Software and Applications',
              id: 'software_apps',
              children: [
                'Applications development',
                'Web development',
                'Mobile development',
                '<abbr title="Software as a Service">SaaS</abbr>/<abbr title="Platform as a Service">PaaS</abbr> implementation and management'
              ]
            },
            {
              name: 'Systems Integration',
              id: 'systems_integration',
              children: [
                'Vertical and Horizontal integration',
                '<abbr title="Enterprise Service Bus">ESB</abbr>, <abbr title="Simple Object Access Protocol">SOAP</abbr>, <abbr title="REpresentational State Transfer">REST</abbr> and GraphQL',
                'Design, implementation and support',
                'Database/<abbr title="Structured Query Language">SQL</abbr> services'
              ]
            },
            {
              name: 'Experience Design',
              id: 'experience_design',
              children: [
                'Customer/User Experience design (CX/UX)',
                'User Interface design (UI)',
                'UX audits/health checks',
                'User engagement/testing',
                'Wireframes and prototyping'
              ]
            }
          ],

          products: [
            {
              updated: 'Last Updated 22nd January 2021',
              name: 'CI Synchronizer',
              description:
                'Do you use both ServiceNow and Lansweeper? Download this product and connect them today! ',
              slug: 'CISynchronizer',
              color: 'orange'
            }
          ],
          caseStudies: [
            {
              id: 0,
              active: true,
              title:
                'Enterprise <abbr title="Information Technology">IT</abbr> Service Management (ITSM)',
              color: 'blue',
              slug: 'enterprise_itsm',
              business_need:
                'Replace ageing on-premise, <abbr title="Information Technology">IT</abbr> only, service management platform with best of breed <abbr title="Software as a Service">SaaS</abbr> solution and leverage for whole-of-business (non-IT) service lines.',
              inclusions: {
                A: [
                  'Migration of all <abbr title="Information Technology Service Management">ITSM</abbr> modules from legacy system (Incident, Problem, Release, Change, Configuration, Request)',
                  'Re-architect and implement revised <abbr title="Configuration Management Database">CMDB</abbr> and migrate all legacy <abbr title="Configuration Item">CI</abbr>s',
                  'All organisation change management',
                  'Implementation of resolver and self-service functionality for <abbr title="Human Resources">HR</abbr>, Procurement, Expense Management, Facilities Management',
                  'Comprehensive integrations into corporate <abbr title="Enterprise Resource Planning">ERP</abbr>. Includes transactional integrations (including approval workflows) and non-transactional master data integrations'
                ],
                B: [
                  'Authentication integration for single sign-on',
                  'Integrated <abbr title="Configuration Management Database">CMDB</abbr> and system monitoring platform for alerting and <abbr title="Configuration Item">CI</abbr> outage reporting',
                  'Multiple external service provider transactional integrations including incident and service request processes',
                  'Integration between Software Asset Management, <abbr title="Configuration Management Database">CMDB</abbr> and Employee Service Request Management platforms',
                  'Implementation of Governance Risk and Compliance, Reporting and Analytics, Project and Portfolio Management, orchestration and run-book automation',
                  'Implemented automated user provisioning addressing multiple service lines including <abbr title="Information Technology">IT</abbr>, <abbr title="Human Resources">HR</abbr> and Facilities'
                ]
              },
              outcome:
                'Issue free transition to new platform (over a 14x month duration). Whole of enterprise solution created business leverage from flexible and extensible solution architecture.',
              testimonials: [
                {
                  content:
                    'This was a high profile, <abbr title="Chief Information Officer">CIO</abbr>-sponsored, project with critical dependencies across many stakeholder groups. Pipefish exceeded expectations in their design and delivery of the solution.',
                  person: 'IT GM, Senior Supplier'
                }
              ],
              pipefish_role: [1, 2, 7, 8, 9, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global, Enterprise (4,000+ users)',
              programme_mgmt: 'Pipefish',
              img:
                'https://elements.envato.com/modern-glass-silhouettes-of-skyscrapers-business-PYLQ86Q',
              img2:
                'https://elements.envato.com/attractive-businesswoman-using-digital-tablet-in-MEFYS5J',
              img3:
                'https://elements.envato.com/young-team-working-on-computers-at-modern-office-4ZP37DL'
            },
            {
              id: 1,
              active: true,
              title: 'Service Request Management',
              color: 'green',
              slug: 'service_request_management',
              business_need:
                'Replace ageing on-premise, service request management platform integrated with <abbr title="Software as a Service">SaaS</abbr> <abbr title="Information Technology Service Management">ITSM</abbr> platform and leverage for end-to-end workflows across the entire organisation. Highly flexible solution able to "shield" end-users and resolvers from rapidly changing organisation.',
              inclusions: {
                A: [
                  'Single self-service portal for all major service lines (<abbr title="Information Technology">IT</abbr>, <abbr title="Human Resources">HR</abbr>, Finance, Procurement, Facilities Management)',
                  'Extension to support any line-of-business service requests including Travel Request Management, Heavy Equipment Maintenance, Compliance Requests etc (in total, 29 service areas adopted the platform)',
                  'Over 500 service catalogue items presented with full context sensitivity for each individual user (based on automatically enumerated user characteristics)',
                  'Self-service access to knowledge articles for all service lines',
                  'Ticket status, including history and approval workflow status'
                ],
                B: [
                  'Two way messaging between users and resolvers within the context of any request or incident ticket',
                  'Data driven dynamic ticket routing engine. Addressing routing needs for global vs local fulfilment teams, in-sourced vs outsourced teams, geographical nuances (e.g. snow clearing requests not visible in particular locations), service line specific rules',
                  'Customer centric, business language drive a “Guide Me” navigation feature which directs users to request forms and knowledge articles',
                  'Full multi-language and multi-currency support',
                  'More than one million service requests processed annually'
                ]
              },
              outcome:
                'Issue free transition to new platform (over a 12x month duration). Mobile enabled, single end user portal for all service requests with rapid self-service form generation process reducing historical latency from months to weeks.',
              testimonials: [],
              pipefish_role: [0, 1, 2, 8, 9, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global, Enterprise (60,000+ users)',
              programme_mgmt: 'Pipefish',
              img: 'https://elements.envato.com/customer-service-WBYXN4V',
              img2: 'https://elements.envato.com/repair-service-request-PXJYY57'
            },
            {
              id: 2,
              active: true,
              title: 'Agile, points-based development agreement',
              color: 'orange',
              slug: 'agile_points_based_agreement',
              business_need:
                'Pipefish had been successfully delivering ongoing Agile software development of a global mining client\'s Enterprise Service Management Platform. The client was moving <abbr title="Information Technology">IT</abbr> service procurement to an “as a service” model and Pipefish proposed a commercial model to transform the <abbr title="Time &amp; Materials">T&amp;M</abbr> software development services to a price per Scrum point model.',
              inclusions: {
                A: [
                  'The customer commits to a "band" of points for the subsequent period (e.g. 50-100 points per sprint). This is usually planned based on the size of the demand backlog',
                  "Ideas for system enhancements (User Stories) are added to a backlog by the Customer's Product Owners",
                  'Pipefish reviews the User Stories and issues an estimated effort (+/-30% <abbr title="Order of Magnitude">OoM</abbr>) to deliver',
                  'Estimated stories are approved by the customer and added to the development backlog',
                  'Stories are taken from the backlog, according to priority, and allocated to the upcoming sprint within the Sprint Planning session'
                ],
                B: [
                  'Pipefish developers review the stories and provide a final estimate (Fixed-price). NOTE: if the final estimate exceeds to <abbr title="Order of Magnitude">OoM</abbr>, approval to proceed is sought',
                  'Stories are developed within a sprint cycle (say two weekly), with review and input sought from Product Owners/<abbr title="Subject Matter Experts">SMEs</abbr> as appropriate',
                  'On completion of the development sprint, the developed code is released into a test environment where the customer conducts User Acceptance Testing (<abbr title="User Acceptance Testing">UAT</abbr>) and raise defects where functionality is not met',
                  'Pipefish fixes any defects and deploys them to the Test environment for customer retesting. NOTE: Pipefish commits to an SLA for the <abbr title="User Acceptance Testing">UAT</abbr> defect rate (e.g. 95% of stories to pass <abbr title="User Acceptance Testing">UAT</abbr> defect free)'
                ]
              },
              outcome:
                'The customer was able to scale the development services up or down to meet the demands of their customers. Additionally, the commercial agreement was outcome focused rather than resource input focused ensuring customers received value for money.',
              testimonials: [],
              pipefish_role: [6],
              cio_watchlist: 'Yes',
              scale:
                'Global, multi-service area Enterprise Service Management (ESM) development (60,000+ users)',
              programme_mgmt: 'Customer',
              img: 'https://elements.envato.com/making-agreement-RCFJYGD',
              img2: 'https://elements.envato.com/signing-agreement-P2MMCP9',
              img3:
                'https://elements.envato.com/management-is-executing-the-secretary-is-taking-PSVZFJD'
            },
            {
              id: 3,
              active: true,
              title: 'Remote Access Optimisation',
              color: 'purple',
              slug: 'remote_access_optimisation',
              business_need:
                'Urgently remediate performance on primary remote access/application virtualisation platform causing significant degradation of key business services delivered by major outsource providers across the globe.',
              inclusions: {
                A: [
                  'Comprehensive business service and technology analysis',
                  'End-to-end definition of user proximity, session proximity, user object proximity, data proximity, application and system proximity and application configuration rules',
                  'Solution architecture taking into account all of the above influences including distance and network latency',
                  'Proof of concept replacement solution delivered within first 30x days and pilot users operating the solution shortly after'
                ],
                B: [
                  'Major reduction in user login times from, in many cases, between 20 and 40 minutes down to less than one minute',
                  'Major reduction in user/session disconnections. From many times per day to none per day',
                  'Extraordinary improvement in individual application performance including start-up time, transactional processing time, user interface latency removed'
                ]
              },
              outcome:
                'Service provider delivery returned to fully operational state and able to meet, and exceed, performance obligations. Reduction in staff turnover directly attributable to system performance. Reduction in overtime costs',
              testimonials: [
                {
                  content:
                    'Pipefish were able to quickly identify and remediate the root cause of the performance issues, restoring the relationship with the service provider and improving the experience of the end users.',
                  person: 'IT VP, Project Sponsor'
                }
              ],
              pipefish_role: [1, 2, 7, 8, 9, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global, Enterprise (60,000+ users)',
              programme_mgmt: 'Pipefish',
              img: 'https://elements.envato.com/young-woman-working-from-home-PK2DZ6R',
              img2: 'https://elements.envato.com/beard-young-man-working-from-home-P85T5LV'
            },
            {
              id: 4,
              active: true,
              title: 'Software Asset Management (SAM)',
              color: 'darkblue',
              slug: 'software_asset_management',
              business_need: 'Audit defence, compliance and software licence cost reduction.',
              inclusions: {
                A: [
                  'Deployed specialised <abbr title="Software Assets Management">SAM</abbr> solution which audits servers and workstations to monitor which products have been installed and when they are used',
                  'Implemented an integration into the customers service request platform to automate:<br /><br />The capture of license details when new ad-hoc installations are detected<br /><br />Deployment and removal automation through integration with enterprise package deployment platform<br /><br />Implementation of an automated removal campaign workflow based on application low- usage',
                  'Real-time audit of compliance through entitlement vs actual consumption metrics'
                ],
                B: [
                  'Two-way integration between Enterprise Service Management (ESM) platform which leverages <abbr title="Configuration Management Database">CMDB</abbr>, self-service request management, end- user survey management',
                  'Multi million dollar liability reduction within first six months'
                ]
              },
              outcome:
                'Corporate wide visibility of implemented applications, application usage and licence entitlements. Coverage including corporate <abbr title="Information Technology">IT</abbr> infrastructure and operational technology infrastructure.',
              testimonials: [
                {
                  content:
                    'The rollout of the SAM tool was delivered by Pipefish in an efficient and effective manner, delivering real savings in license costs and providing a real time view of software usage.',
                  person: 'IT VP, Project Sponsor'
                }
              ],
              pipefish_role: [1, 2, 7, 8, 9, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global, Enterprise (1,000+ applications)',
              programme_mgmt: 'Pipefish',
              img:
                'https://elements.envato.com/software-update-electronic-device-display-concept-PF2M879',
              img2: 'https://elements.envato.com/web-design-software-P53CEVL'
            },
            {
              id: 5,
              active: true,
              title:
                'Major <abbr title="Information Technology">IT</abbr> Contract Programme Management',
              color: 'orange',
              slug: 'major_it_contract_programme_management',
              business_need:
                'Manage the development of a novel, world leading <abbr title="Information Technology">IT</abbr> services "as-a-Service" contract to facilitate the customer\'s transformational objectives for <abbr title="Information Technology">IT</abbr> service delivery.',
              inclusions: {
                A: [
                  'Management of the production of a single major contract, consisting of two drafting variations to address per-vendor requirements',
                  'Management of the selection and award process and final contract drafting (single vendor) through to contract execution',
                  'An agreement based on "as-a-Service" constructs rather a traditional input driven and resource based model',
                  'Pipefish managed the definition of all services, service levels working across dozens of <abbr title="Information Technology">IT</abbr> service owners and both internal and external legal counsel'
                ],
                B: [
                  'From selection of the final two candidate vendors, the customer needed the contract finalised within six weeks<br /><br />External counsel estimated duration was more likely 12x weeks<br /><br />Internal service line owners had limited time to commit to the activity',
                  'Pipefish applied an Agile approach to the contract preparation and the agreement was prepared within the required six weeks',
                  'Pipefish were subsequently awarded Programme Management of the post-execution transition phase including a comprehensive range of service-by-service transitions and associated organisational change'
                ]
              },
              outcome: 'Contract development and execution over a very short duration.',
              testimonials: [
                {
                  content:
                    'Pipefish were able to deliver an excellent Project Management approach that delivered an outcome no one thought could be achieved.',
                  person: 'IT VP, Senior Supplier'
                }
              ],
              pipefish_role: [4, 5, 6, 7, 8],
              cio_watchlist: 'Yes',
              scale: 'Global, Whole of <abbr title="Information Technology">IT</abbr> services',
              programme_mgmt: 'Pipefish',
              img: 'https://elements.envato.com/manager-phoning-72T8P5D'
            },
            {
              id: 6,
              active: true,
              title:
                '<abbr title="Human Resources">HR</abbr> Service-Delivery Transformation Methodology',
              color: 'red',
              slug: 'hr_service_delivery_transformation',
              business_need:
                'The Human Resources department of a global mining client was undertaking a transformation of their service delivery model focusing on user-centred design. Pipefish provided an agile, Lean UX methodology to structure collaboration between <abbr title="Human Resources">HR</abbr> <abbr title="Subject Matter Experts">SMEs</abbr> and Pipefish delivery resources.',
              inclusions: {
                A: [
                  'Pipefish worked with customer <abbr title="Subject Matter Experts">SMEs</abbr> and management to define and execute a methodology to ensure an efficient engagement model',
                  'The methodology leveraged User-centred design principles to deliver rapid prototypes ahead of build activities',
                  'End-user testing was conducted against prototypes to evaluate their effectiveness',
                  'The methodology provided a framework to evaluate the business benefits of any solution throughout the prototype and build phases to allow a "fail fast" approach'
                ],
                B: [
                  'A "feature-flagged" enablement approach allowed for production prototyping by pilot groups and inline sentiment feedback captured real-time usability',
                  'The process "book-ended" the Pipefish Scrum delivery model',
                  'The process facilitated decision making through the definition of stage-pass criteria which removed subjectivity'
                ]
              },
              outcome:
                'Project <abbr title="Subject Matter Experts">SMEs</abbr> were benefited through the connection of <abbr title="Human Resources">HR</abbr> process improvement and technical delivery resources resulting in high-throughput.',
              testimonials: [
                {
                  content:
                    'We delivered higher than expected throughput by collaborating within a structured framework.',
                  person: 'HR SME'
                },
                {
                  content:
                    'We were able to respond to customer problem statements in a responsive way achieving better end-user outcomes.',
                  person: 'HR Programme Director'
                }
              ],
              pipefish_role: [0, 1, 2, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global, Whole of <abbr title="Human Resources">HR</abbr> services',
              programme_mgmt: 'Customer',
              additional_content: {
                img: ['process-attachment-6.png']
              },
              img: 'https://elements.envato.com/making-agreement-RCFJYGD'
            },
            {
              id: 7,
              active: true,
              title: '<abbr title="Human Resources">HR</abbr> Crew-Swap Service Request',
              color: 'blue',
              slug: 'hr_crew_swap_service_request',
              business_need:
                'Under the <abbr title="Human Resources">HR</abbr> transformation programme a problem was identified relating to the complexity of a crew lead requesting that two shift workers swap their shifts. Four separate service requests had to be submitted referencing multiple <abbr title="Human Resources">HR</abbr> systems resulting in wasted administration and processing time.',
              inclusions: {
                A: [
                  'A problem had been raised by mine crew team leads as to the complexity in requesting two team members swap shifts',
                  'A solution was identified using the user-centred design principles of design ideation sessions and testing with crew-leads',
                  'The solution was mocked up as a clickable prototype and end-user testing was conducted to evaluate the effectiveness of the solution',
                  'Refinements to the solution was identified via the end- user testing process and incorporated into the final design requirements for build'
                ],
                B: [
                  'The solution was implemented on the organisations enterprise service management platform and released to a production pilot user group',
                  'A custom developed sentiment feedback tool gathered end-user feedback which was monitored over the pilot period',
                  'The pilot results were evaluated and a decision was made to launch the solution to the entire production user base',
                  'In the first 6 months, the new service request process has been used over 700 times'
                ]
              },
              outcome: 'A service request process that streamlined the process for crew leads.',
              testimonials: [
                {
                  content:
                    'The credibility gained via the success of this initiative resulted in recognition of the efficiency and effectiveness of user-centred design resulting in an expansion of the programme scope.',
                  person: 'HR SME'
                },
                {
                  content:
                    "The outcome of this initiative unlocked the programme's ability to tackle riskier business problems",
                  person: 'HR Programme Director'
                }
              ],
              pipefish_role: [0, 1, 2, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global, Whole of <abbr title="Human Resources">HR</abbr> services',
              programme_mgmt: 'Customer',
              img: 'https://elements.envato.com/man-in-suit-in-corporation-PW9JPCN'
            },
            {
              id: 8,
              active: true,
              title:
                'MS <abbr title="Structured Query Language">SQL</abbr> Enterprise Edition Remediation',
              color: 'purple',
              slug: 'sql_enterprise_remediation',
              business_need:
                'Unnecessary consumption of Microsoft <abbr title="Structured Query Language">SQL</abbr> Enterprise Edition leading to significantly increased cost of licences.',
              inclusions: {
                A: [
                  'Pipefish were already assisting the customer with an Enterprise Agreement license renewal process',
                  'As part of the engage Pipefish assisted in the review and determination of unnecessary consumption of Microsoft <abbr title="Structured Query Language">SQL</abbr> Enterprise Edition, instead of other lower cost alternatives such as Express and Standard Edition',
                  'Determined if each of the Enterprise installs was actually utilising any of the Enterprise features, or if other entitlements provided an alternative option for the <abbr title="Structured Query Language">SQL</abbr> Edition',
                  'Located and negotiated with the system owners/<abbr title="Database Administrator">DBA</abbr>s a number of treatment options, many of which involved the process of downgrading the <abbr title="Structured Query Language">SQL</abbr> instance to the Standard edition'
                ],
                B: [
                  'Scheduled the system downgrade within the organisations change management process',
                  'Executed the downgrade (with rollback option if required), across a large number of installations globally',
                  'In all cases, the entire fleet of just under 300 remediations were completed without any unplanned business interruption'
                ]
              },
              outcome:
                'Approximately $8M cost avoidance associated with removal of unnecessary use of Enterprise Edition over four (4) months at a cost of ~$400K.',
              testimonials: [
                {
                  content:
                    'Pipefish were able to deliver an exceptional outcome, resulting is significant ongoing cost savings for the business. They brought skilled resources to this project with minimal notice and tight timeframes to deliver.',
                  person: 'VP of IT'
                }
              ],
              pipefish_role: [0, 1, 2, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Global',
              programme_mgmt: 'Pipefish',
              img: 'https://elements.envato.com/man-in-suit-in-corporation-PW9JPCN'
            },
            {
              id: 9,
              active: true,
              title:
                '<abbr title="Information Technology Service Management">ITSM</abbr> process review and toolset assessment',
              color: 'green',
              slug: 'itsm_process_review_assessment',
              business_need:
                'The need to establish IT Service Management (ITSM) practices that support an agile environment was identified by the new <abbr title="Chief Information Officer">CIO</abbr> of a well known insurance company. <br /><br />With low process maturity and the lack of a suitable <abbr title="Information Technology Service Management">ITSM</abbr> toolset Pipefish was engaged to undertake a process review with a view to process improvement and assessment of one or more <abbr title="Information Technology Service Management">ITSM</abbr> tools.',
              inclusions: {
                A: [
                  'Pipefish reviewed existing processes and tools across core <abbr title="Information Technology Service Management">ITSM</abbr> processes',
                  'Established a process assessment approach that can be leveraged for future maturity and process effectiveness assessments',
                  'Engaged with resources from all <abbr title="Information Technology">IT</abbr> teams and levels to ensure a comprehensive understanding of <abbr title="Information Technology">IT</abbr> operations',
                  'A number of process improvement recommendations were made, including practical guidance on how to deliver these'
                ],
                B: [
                  'Process improvements were able to be realised even with the lack of an adequate <abbr title="Information Technology Service Management">ITSM</abbr> tool',
                  'A market scan of suitable <abbr title="Information Technology Service Management">ITSM</abbr> tools was conducted and assessment process undertaken. Positioned the client to complete the selection process with two shortlisted vendors',
                  'Focussed on building capability of key <abbr title="Information Technology">IT</abbr> resources fulfilling operational <abbr title="Information Technology Service Management">ITSM</abbr> roles'
                ]
              },
              outcome:
                'Designed and implemented <abbr title="Information Technology">IT</abbr> service management process improvements and guided the shortlisting of <abbr title="Information Technology Service Management">ITSM</abbr> tools to two preferred vendors. <br /><br />Pipefish continues to work with this client at scheduled checkpoints to provide ongoing advice and assistance to grow <abbr title="Information Technology Service Management">ITSM</abbr> maturity and support continuous improvement.',
              testimonials: [
                {
                  content:
                    "We've been given a 'leg-up' in transforming our processes and a framework to support us to continually improve. We've gone much further beyond where we would have been able to go on our own.",
                  person: 'ITSM Manager, Project Lead'
                },
                {
                  content:
                    'Fantastic outcome. Appreciated the way Pipefish came in and truly partnered with us. Our entire team was fully and actively engaged throughout the process and was left with a solid understanding of the core concepts over and above the high quality deliverables (taught us to fish)',
                  person: '<abbr title="Chief Information Officer">CIO</abbr>, Project Sponsor)'
                }
              ],
              pipefish_role: [0, 1, 3, 5],
              // pipefish_role: [0, 1, 2, 10, 11, 12],
              cio_watchlist: 'Yes',
              scale: 'Whole of IT',
              programme_mgmt: 'Customer',
              img: 'https://elements.envato.com/man-in-suit-in-corporation-PW9JPCN'
            }
          ],
          people: [
            {
              slug: 'beau_holland',
              firstName: 'Beau',
              lastName: 'Holland',
              title: 'Partner',
              linkedIn: 'https://www.linkedin.com/in/hollandbeau/',
              spotlight: false,
              partner: true,
              email: 'beau.holland@pipefish.com.au',
              summary: [
                'Beau is an experienced solution architect, technical leader, and developer with 20 years’ experience.  I help design, implement, and guide the completion of highly complex enterprise solutions. He has a proven track record building technical and business relationships, driving decisions collaboratively and establishing credibility with customers. His inquisitive nature, appetite for technology and industry experience helps deliver exceptional customer results.',
                'Recent years have been focused on the architecture, design, and build of cloud-based solutions.'
              ]
            },
            {
              slug: 'christoph_brinkmann',
              firstName: 'Christoph',
              lastName: 'Brinkmann',
              title: 'Security + Applications development',
              linkedIn: 'https://au.linkedin.com/in/christoph-brinkmann-56941b157',
              spotlight: false,
              email: 'christoph.brinkmann@pipefish.com.au',
              summary: [
                'Christoph is an application developer with 5 years of experience working with a wide range of technologies. He has been a part of many different projects within the mining industry as a ServiceNow developer; and government sector as a web developer and identity manager.',
                'Christoph specialises in Identity and Access Management (IAM), web application security and the development of web applications, including working with and developing for ServiceNow. Having completed his IAM and Access Management Specialist (AMS) certifications through the Identity Management Institute, he can help analyse, design and implement an Identity and Access profile for an organisation.'
              ]
            },
            {
              slug: 'craig_castledine',
              firstName: 'Craig',
              lastName: 'Castledine',
              title: 'Partner',
              linkedIn: 'https://www.linkedin.com/in/craigcastledine/ ',
              spotlight: false,
              partner: true,
              email: 'craig.castledine@pipefish.com.au',
              summary: [
                'Craig is a highly experienced, multi-skilled designer and developer who has been leading the creation of web and mobile solutions for over 20 years.',
                'He has worked extensively in Australia and the United Kingdom, creating solutions for leading organisations and brands in each region.',
                "Craig's experience covers the entire lifecycle of a product, from user/stakeholder research and requirements, user experience design, solution architecture, system design, development and ongoing iteration and refinement. Recent years have been focused on the architecture, design, user experience and build of cloud-based solutions.",
                ''
              ]
            },
            {
              slug: 'eric_gan',
              firstName: 'Eric',
              lastName: 'Gan',
              title: 'Applications development',
              linkedIn: 'https://au.linkedin.com/in/jitao-eric-gan-35349752',
              spotlight: false,
              email: 'eric.gan@pipefish.com.au',
              summary: [
                'Eric has worked in the IT industry for over 10 years with extensive knowledge and experience in web-based application design, implementation and administration. Recent projects have been focused on the architecture, design and build of cloud-based solutions in both ServiceNow and other cloud-based platforms.'
              ]
            },
            {
              slug: 'glen_moor',
              firstName: 'Glen',
              lastName: 'Moor',
              title: 'Director',
              linkedIn: 'https://au.linkedin.com/in/glen-moor-7491067',
              spotlight: false,
              partner: true,
              director: true,
              email: 'glen.moor@pipefish.com.au',
              summary: [
                'Glen has an IT career spanning almost 30 years which includes a wide variety of technical domains, business domains, clients and geographies. For the past 15 to 20 years Glen has led multi-disciplinary teams to deliver projects and programs globally and at enterprise scale. A significant number of recent projects and programs led by Glen have been appointed by C-level executives to address challenges or achieve opportunities involving tens of millions of dollars in project spend and business value in excess of 100+ million dollars.'
              ]
            },
            {
              slug: 'hamish_beattie',
              firstName: 'Hamish',
              lastName: 'Beattie',
              title: 'UX/UI design & research',
              linkedIn: 'https://au.linkedin.com/in/hamishbeattie',
              spotlight: true,
              email: 'hamish.beattie@pipefish.com.au',
              summary: [
                'Hamish is a creator with over 20 years of experience designing, developing and leading the creation of web and mobile solutions. He has worked in a number of industries, including government, finance, creative agencies, sporting, childcare, mining and telecommunications.',
                'He is equally comfortable in code as with designing high-fidelity user interfaces and wireframes. Recent projects have been focused on the architecture, design, user experience and build of cloud-based solutions.'
              ]
            },
            {
              slug: 'ian_wilson',
              firstName: 'Ian',
              lastName: 'Wilson',
              title: 'Business analysis',
              linkedIn: 'https://www.linkedin.com/in/ian-wilson-44b0101/',
              spotlight: false,
              email: 'ian.wilson@pipefish.com.au',
              summary: [
                'Ian is an Information Technology professional with over 18 years of industry experience including a comprehensive understanding of the software development lifecycle as well as infrastructure support and maintenance.',
                'Ian has in-depth professional experience across a wide range of industries including Banking, Insurance, Superannuation, Mining, Hospitality, Construction, and Retail.'
              ]
            },
            {
              slug: 'jayden_soanes',
              firstName: 'Jayden',
              lastName: 'Soanes',
              title: 'Applications development',
              linkedIn: 'https://www.linkedin.com/in/jaydensoanes/',
              spotlight: false,
              email: 'jayden.soanes@pipefish.com.au',
              summary: [
                'Jayden is a junior software engineer with experience working professionally with web development technologies. He has been involved in projects aimed towards the insurance and construction industries as both web and mobile application developer.',
                'He specialises in full-stack web development. Having successfully completed a bachelor’s degree in computer science and working professionally as a full-stack web developer, he can help design and implement technical solutions for an organisation.'
              ]
            },
            {
              slug: 'jeremy_dein',
              firstName: 'Jeremy',
              lastName: 'Dein',
              title: 'Applications development',
              linkedIn: 'https://au.linkedin.com/in/jeremy-dein/',
              spotlight: false,
              email: 'jeremy.dein@pipefish.com.au',
              summary: [
                'Jeremy is a developer with over 4 years’ experience designing, developing and executing web-based solutions. He is experienced in all stages of the software development lifecycle, working exclusively in a successful Agile development cycle for the past 3+ years.',
                'Jeremy prides himself on having high attention to detail, logically working through all solutions to ensure that the outcome is best for the end user and stakeholders involved.'
              ]
            },
            {
              slug: 'jordan_howarth',
              firstName: 'Jordan',
              lastName: 'Howarth',
              title: 'Partner',
              linkedIn: 'https://au.linkedin.com/in/jordanhowarth',
              spotlight: false,
              partner: true,
              email: 'jordan.howarth@pipefish.com.au',
              summary: [
                'Jordan is a solution architect with over 15 years of experience has worked in resources, finance, utilities, health and property in the design and development of distributed applications across a range of platforms and technologies.',
                'Specialising in application integration he delivers complete enterprise integration solutions and can establish the integration competency centres or C4Es required to govern them. Having completed TOGAF certification and with a history of solution development, he can align the strategic importance of project goals, analyse requirements then architect and develop solutions with agility.'
              ]
            },
            {
              slug: 'lee_crebbin',
              firstName: 'Lee',
              lastName: 'Crebbin',
              title: 'Project management + Business analysis',
              linkedIn: 'https://au.linkedin.com/in/lee-crebbin-7838811b',
              spotlight: false,
              email: 'luis.cyrillo@pipefish.com.au',
              summary: [
                'Lee has over 15 years’ experience as a management consultant, project manager and business analyst, having worked in operational and strategy divisions, project teams and consulting groups, delivering a wide variety of engagements across a number of industries including funds management, banking, mining, energy, utilities, transportation and oil and gas.'
              ]
            },
            {
              slug: 'luis_cyrillo',
              firstName: 'Luis',
              lastName: 'Cyrillo',
              title: 'Applications development',
              linkedIn: 'https://au.linkedin.com/in/luis-cyrillo-2458b3123',
              spotlight: false,
              email: 'luis.cyrillo@pipefish.com.au',
              summary: [
                'Luis is an IT systems analyst/developer with over 15 years of experience in the design and implementation of enterprise-scale solutions.',
                'Throughout his career, Luis has focussed heavily on the implementation of database solutions including reporting and analysis. '
              ]
            },
            {
              slug: 'mario_quinones',
              firstName: 'Mario',
              lastName: 'Quinones',
              title: 'Applications development',
              linkedIn: 'https://au.linkedin.com/in/marioquinones',
              spotlight: false,
              email: 'mario.quinones@pipefish.com.au',
              summary: [
                'Mario is a software developer with over 20 years of experience and has worked in IT, and the resources and health industries in the design, integration and development of distributed applications across a range of platforms and technologies.',
                'Specialising in application integration, his range of skills is applicable to the delivery of complete enterprise solutions. Having completed the ServiceNow Administration certification and with a history of solution development he can align the strategic importance of project goals, analyse requirements, and then architect and develop solutions using an Agile methodology.'
              ]
            },
            {
              slug: 'mark_sakzewski',
              firstName: 'Mark',
              lastName: 'Sakzewski',
              title: 'Director',
              linkedIn: 'https://au.linkedin.com/in/mark-sakzewski-94141420',
              spotlight: false,
              partner: true,
              director: true,
              email: 'mark.sakzewski@pipefish.com.au',
              summary: [
                'Mark has over 20 years’ experience in managing the implementation of enterprise-scale solutions. He has directed the delivery of solutions spanning many technology and business domains.'
              ]
            },
            {
              slug: 'martin_kammann',
              firstName: 'Martin',
              lastName: 'Kammann',
              title: 'Applications development',
              linkedIn: 'https://www.linkedin.com/in/martin-kammann-72104910',
              spotlight: false,
              email: 'martin.kammann@pipefish.com.au',
              summary: [
                'Martin is a software engineer and systems analyst with 25 years of experience designing and implementing large scale information systems.',
                'Throughout his career, Martin has not only focused on creating solutions for his customers, but also developed tools and middleware to simplify and speed up the development process. He has worked in a variety of industries, including banking, insurance, retail, and real estate. In the past 15 years, Martin has developed and maintained a full supply chain solution for the Costa group.'
              ]
            },
            {
              slug: 'matthew_coyle',
              firstName: 'Matthew',
              lastName: 'Coyle',
              title: 'Platform architecture',
              linkedIn: 'https://www.linkedin.com/in/matt-coyle-27990b1',
              spotlight: false,
              email: 'matthew.coyle@pipefish.com.au',
              summary: [
                'Matthew is a professional ITSM consultant with a proven track record of successful ServiceNow implementations, including highly customised solutions and complex integrations. Matthew has over 16 years’ experience in software development, 10 years’ experience leading multi-person developer teams, and more than 5 years’ solution architecture experience.',
                'Matthew’s work experience has spanned both the public and private sector, across a range of industries, including several years at a global mining company and more than a decade within the government sector (education and corporate services). A significant portion of his career has been devoted to software delivery and the design, build and support of solutions which solve complex business problems on large-scale enterprise platforms such as SAP and ServiceNow.'
              ]
            },
            {
              slug: 'morgen_heywood',
              firstName: 'Morgen',
              lastName: 'Heywood',
              title: 'UX + Service design + Business analysis',
              linkedIn: 'https://au.linkedin.com/in/morgenheywood',
              spotlight: false,
              email: 'morgen.heywood@pipefish.com.au',
              summary: [
                'Morgen is a multi-skilled HR / IT professional with experience in both employee and consulting roles. She is particularly passionate about improvement and innovation, shaping her career skillset around these areas.',
                'With formal qualifications in design, LEAN/Six Sigma, Agile and design thinking, she has also gained significant on-the-job experience in project management, process improvement, business analysis and service design.',
                'A skilled workshop facilitator and problem solver, Morgen’s most recent projects used co-design to improve HR technology experiences at a large mining company. '
              ]
            },
            {
              slug: 'scott_webster',
              firstName: 'Scott',
              lastName: 'Webster',
              title: 'Applications development',
              linkedIn: 'https://au.linkedin.com/in/scott-webster-b434a64',
              spotlight: false,
              email: 'scott.webster@pipefish.com.au',
              summary: [
                'Scott is an IT systems analyst/developer with over 15 years of experience in the design, implementation, management and support of enterprise-scale solutions.',
                'Throughout his career, Scott has focused heavily on the implementation of database solutions including integrations, reporting, analysis and optimisation.'
              ]
            },
            {
              slug: 'susan_halloran',
              firstName: 'Susan',
              lastName: 'Halloran',
              title: 'Partner',
              linkedIn: 'https://www.linkedin.com/in/susanhalloran/',
              spotlight: false,
              partner: true,
              email: 'susan.halloran@pipefish.com.au',
              summary: [
                'Susan is a senior business analyst with over 20 years’ experience working in operational and project capacities to assist businesses to leverage technology and improve business process.',
                'For the past decade, Susan’s focus has been on continuous improvement within IT service management. This has included working for mature and geographically large organisations seeking to transition from in-house to a managed-service arrangement to smaller and less mature organisations seeking to transform their core IT support and service delivery processes.',
                'Susan has experience working within an agile environment continually improving service management practices leveraging the ServiceNow platform.'
              ]
            },
            {
              slug: 'jack_lyons',
              firstName: 'Jack',
              lastName: 'Lyons',
              title: 'Applications development',
              linkedIn: 'https://au.linkedin.com/in/jacklyons89/',
              spotlight: false,
              email: 'jack.lyons@pipefish.com.au',
              summary: [
                'Jack has over 5 years’ experience in Front End Web Development. He has developed solutions in the eCommerce, enterprise software, government, real estate and logistics sectors. Jack has worked as the lead front end developer for various start-ups both locally and abroad implementing responsive, feature-rich web-applications using modern JavaScript. He particularly enjoys working with Vue.js and GraphQL.'
              ]
            },
            {
              slug: 'angus_wood',
              firstName: 'Angus',
              lastName: 'Wood',
              title: 'Applications development',
              linkedIn: 'https://www.linkedin.com/in/angwoo/',
              spotlight: false,
              email: 'angus.wood@pipefish.com.au',
              summary: [
                'Angus is an experienced Web Developer skilled in User Experience (UX), API Development, Back-End Web Development, JavaScript, and Redux.js. He is a strong engineering professional with a Bachelor of Information Technology focused in Software Information Systems from The University of Queensland.'
              ]
            },
            {
              slug: 'martin_bosticky',
              firstName: 'Martin',
              lastName: 'Bosticky',
              title: 'Applications development',
              linkedIn: 'https://www.linkedin.com/in/martin-b-8168513/',
              spotlight: false,
              email: 'martin.bosticky@pipefish.com.au',
              summary: [
                'Martin is a Senior creative C#/.NET/React/Python/C++/Java full-stack developer with 20 years of experience in the financial services, online gaming, medical, transport and human resource industries. A clear communicator, with experience in the full product life cycle including testing and production support. Martin is competent in agile development, test automation, database, back-end, protocol, web services and front end development.'
              ]
            },
            {
              slug: 'tony_roffey',
              firstName: 'Tony',
              lastName: 'Roffey',
              title: 'Programme + Project management',
              linkedIn: 'https://au.linkedin.com/in/tonyroffey/',
              spotlight: false,
              email: 'tony.roffey@pipefish.com.au',
              summary: [
                'Tony is a project manager with over 15 years of program and project experience in delivering complex global IT solutions across the government, mining, NFP, and finance sectors.'
              ]
            }
          ],
          state: {
            showBackdrop: false,
            contactUsModal: {
              open: false,
              submitting: false,
              title: null,

              name: '',
              email: '',
              phone: '',
              msg: '',
              interests: '',
              emailSent: false,
              errors: [],
              errorMsg: null
            },
            productRegisterModal: {
              open: false,
              submitting: false,
              title: null,
              productName: '',
              name: '',
              organisation: '',
              country: '',
              email: '',
              phone: '',
              terms: false,
              contactMe: true,
              emailSent: false,
              errors: [],
              errorMsg: null
            }
          }
        };
      },
      // Lifecycle
      created() {
        var vi = this;
        // Iterate all case studies and assign them a dynamic index value based on their sequence.
        // This is just in case any supplied sequence is incorrect.
        // Drives the infinate case study loop navigation
        _.each(vi.caseStudies, function(value, key) {
          value.index = key;
          if (key === 0) {
            // First item
            value.prev = {
              title: vi.caseStudies[vi.caseStudies.length - 1].title,
              slug: vi.caseStudies[vi.caseStudies.length - 1].slug
            };
            value.next = {
              title: vi.caseStudies[key + 1].title,
              slug: vi.caseStudies[key + 1].slug
            };
          } else if (key === vi.caseStudies.length - 1) {
            // Last item
            value.prev = {
              title: vi.caseStudies[key - 1].title,
              slug: vi.caseStudies[key - 1].slug
            };
            value.next = {
              title: vi.caseStudies[0].title,
              slug: vi.caseStudies[0].slug
            };
          } else {
            // All others
            value.prev = {
              title: vi.caseStudies[key - 1].title,
              slug: vi.caseStudies[key - 1].slug
            };
            value.next = {
              title: vi.caseStudies[key + 1].title,
              slug: vi.caseStudies[key + 1].slug
            };
          }
        });
      },
      methods: {
        // --------------------------------------------------
        // Store methods
        // --------------------------------------------------
        // Contact Us
        // --------------------------------------------------
        // isContactUsModalOpen: function() {
        //   return this.state.contactUsModal.open;
        // },
        toggleContactUsModal(params) {
          this.$utils.log(['-----Store::toggleContactUsModal()']);
          this.$utils.log(['params', JSON.stringify(params, null, 4)]);
          this.state.contactUsModal.open = !this.state.contactUsModal.open;
          this.resetContactUsData();
          this.state.showBackdrop = !this.state.showBackdrop;
          if (params && params.title) {
            this.state.contactUsModal.interests = params.title;
          }
          // this.$emit('StoreToggleContact', this.state.contactUsModal.open);
        },
        closeContactUsModal() {
          if (!this.state.contactUsModal.submitting) {
            this.resetContactUsData();
            this.state.contactUsModal.open = false;
            this.state.showBackdrop = false;
            // this.$emit('StoreToggleContact', this.state.contactUsModal.open);
          }
        },
        resetContactUsData: function() {
          this.$utils.log(['-----Store::resetContactUsData()']);
          this.state.contactUsModal.name = '';
          this.state.contactUsModal.email = '';
          this.state.contactUsModal.msg = '';
          this.state.contactUsModal.interests = '';
          this.state.contactUsModal.errors = [];
          this.state.contactUsModal.emailSent = false;
          this.state.contactUsModal.errorMsg = '';
          this.$utils.log([
            'this.state.contactUsModal',
            JSON.stringify(this.state.contactUsModal, null, 4)
          ]);
        },

        // --------------------------------------------------
        // Store methods
        // --------------------------------------------------
        // Product Download
        // --------------------------------------------------
        // isproductDownloadModalOpen: function() {
        //   return this.state.productDownloadModal.open;
        // },
        toggleProductRegisterModal(productName) {
          this.state.productRegisterModal.open = !this.state.productRegisterModal.open;
          this.resetProductRegisterData();
          this.state.showBackdrop = !this.state.showBackdrop;

          if (productName) {
            this.state.productRegisterModal.productName = productName;
          }

          // this.$emit('StoreToggleContact', this.state.productRegisterModal.open);
        },
        closeProductRegisterModal() {
          if (!this.state.productRegisterModal.submitting) {
            this.resetProductRegisterData();
            this.state.productRegisterModal.open = false;
            this.state.showBackdrop = false;
            // this.$emit('StoreToggleContact', this.state.productRegisterModal.open);
          }
        },
        resetProductRegisterData: function() {
          this.$utils.log(['-----Store::resetProductRegisterData()']);
          this.state.productRegisterModal.productName = '';
          this.state.productRegisterModal.organisation = '';
          this.state.productRegisterModal.country = '';
          this.state.productRegisterModal.phone = '';
          this.state.productRegisterModal.title = '';
          this.state.productRegisterModal.terms = false;
          this.state.productRegisterModal.contactMe = true;
          this.state.productRegisterModal.name = '';
          this.state.productRegisterModal.email = '';
          this.state.productRegisterModal.msg = '';
          this.state.productRegisterModal.interests = '';
          this.state.productRegisterModal.errors = [];
          this.state.productRegisterModal.emailSent = false;
          this.state.productRegisterModal.errorMsg = '';
          this.$utils.log([
            'this.state.productRegisterModal',
            JSON.stringify(this.state.productRegisterModal, null, 4)
          ]);
        },

        // --------------------------------------------------
        // Store constructs
        // --------------------------------------------------
        dispatch: function(method, params) {
          this[method].call(this, params);
          // this.updateStorage();
        }
      }
    });
    Vue.prototype.Store = root;
  }
};

export default PFStore;
